import {createHashRouter, Navigate, RouterProvider} from "react-router-dom";
import Layout from "./Layout";
import Home from "./home/Home";
import NotFound from "./NotFound";
import React from "react";
import Contact from "./contact/Contact";
import Aisp from "./aisp/Aisp";
import Pisp from "./pisp/Pisp";
import AispDocumentation from "./documentation/AispDocumentation";
import PispDocumentation from "./documentation/PispDocumentation";
import Kpi from "./kpi/Kpi";
import Oauth2 from "./oauth2/Oauth2";
import Oauth2Documentation from "./documentation/Oauth2Documentation";


const router = createHashRouter([
    {
        path: "/",
        element: <Layout />,
        children: [{
            errorElement: <NotFound/>
        },
            {
                path:"/",
                element:<Navigate to="/home" />
            },
            {
                path:"/home",
                handle: {
                    crumb: () => "Accueil",
                    isLinkable:() => true
                },
                children: [
                    {
                        index: true,
                        element:<Home />,
                    },
                    {
                        path:"contact",
                        element:<Contact />,
                        handle: {
                            crumb: () => "Contact",
                            isLinkable:() => false
                        }
                    },
                    {
                        path:"kpi",
                        element:<Kpi />,
                        handle: {
                            crumb: () => "KPI",
                            isLinkable:() => false
                        },
                    },]
            },
            {
                path:"/aisp",
                handle: {
                    crumb: () => "AISP",
                    isLinkable:() => true
                },
                children: [{
                    index: true,
                    element:<Aisp />,

                },
                    {
                        path: "documentation",
                        element:<AispDocumentation />,
                        handle: {
                            crumb: () => "Documentation AISP",
                            isLinkable:() => false
                        },
                    },
                ]
            },
            {
                path:"/oauth2",
                handle: {
                    crumb: () => "OAUTH2",
                    isLinkable:() => true
                },
                children: [{
                    index: true,
                    element:<Oauth2 />,

                },
                    {
                        path: "documentation",
                        element:<Oauth2Documentation />,
                        handle: {
                            crumb: () => "Documentation OAUTH2",
                            isLinkable:() => false
                        },
                    },
                ]
            },
            {
                path:"/pisp",
                handle: {
                    crumb: () => "PISP",
                    isLinkable:() => true
                },
                children: [{
                    index: true,
                    element:<Pisp />
                },
                    {
                        path: "documentation",
                        element:<PispDocumentation />,
                        handle: {
                            crumb: () => "Documentation PISP",
                            isLinkable:() => false
                        },
                    },
                ]
            },
        ],
    },
], {basename:"/"});



const Router= () => {
    return <RouterProvider router={router} />
}

export default Router
